// extracted by mini-css-extract-plugin
export default {"DropdownCell":"single-select-renderer-module__DropdownCell--DIdBS"};